<template>
  <svg
    v-if="iconName === 'icon-alarm'"
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28">
    <g
      fill="none"
      fill-rule="evenodd"
      stroke="#FFF">
      <path
        stroke-linecap="round"
        stroke-width="1.494"
        d="M14 5c4.06.005 6.09 2.063 6.09 6.173 0 6.166.962 5.93 2.631 7.485 1.67 1.555 1.74 4.342 0 4.342H14M14 5c-4.06.005-6.09 2.063-6.09 6.173 0 6.166-.962 5.93-2.631 7.485-1.67 1.555-1.74 4.342 0 4.342H14"/>
      <path
        stroke-width="1.657"
        d="M11 23a3 3 0 0 0 6 0"/>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'icon-menu'"
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="41"
    viewBox="0 0 41 41">
    <g
      fill="#FFF"
      fill-rule="evenodd">
      <rect
        width="35"
        height="2"
        x="3"
        y="7"
        fill-rule="nonzero"
        rx="1"/>
      <rect
        width="35"
        height="2"
        x="3"
        y="20"
        fill-rule="nonzero"
        rx="1"/>
      <rect
        width="20"
        height="2"
        x="3"
        y="33"
        fill-rule="nonzero"
        rx="1"/>
      <path
        stroke="#FFF"
        stroke-linejoin="round"
        d="M37.875 34.375l-6.75 4.5v-9z"/>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'codesys-page'"
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="41"
    viewBox="0 0 41 41">
    <g
      fill="none"
      fill-rule="evenodd"
      stroke="#FFF"
      stroke-width="1.5">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M7 31h10M22.75 31H33"/>
      <path d="M17.75 28.75h4.5v4.5h-4.5z"/>
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M7 19h16M29 19h4"/>
      <path d="M23.75 17.75h4.5v4.5h-4.5z"/>
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M33 9H17.75M11.75 9H7"/>
      <path d="M17 11.25h-4.5v-4.5H17z"/>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'icon-nodes'"
    xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41">
    <g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-width="2">
      <path d="M9.5 18a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11zm23 16a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11zM21 12v17-17zm-6 1h6-6zm6 15h6-6z"/>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'icon-workloads'"
    xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41">
    <g fill="#FFF" fill-rule="nonzero">
      <path d="M16.507 33.21h7.25c.436 0 .726-.287.726-.719V3.72c0-.431-.29-.719-.725-.719h-7.25c-.436 0-.726.288-.726.72V32.49c0 .432.29.72.725.72zm.725-28.771h5.8v27.333h-5.8V4.439zM4.907 33.21h7.25c.435 0 .725-.46.725-1.15v-20.7c0-.69-.29-1.15-.725-1.15h-7.25c-.436 0-.726.46-.726 1.15v20.7c0 .69.29 1.15.726 1.15zm.725-21.44h5.8v20h-5.8v-20zm22.476 21.44h7.25c.436 0 .726-.288.726-.72V10.912c0-.431-.29-.719-.725-.719h-7.25c-.436 0-.726.288-.726.72V32.49c0 .432.29.72.725.72zm.725-21.58h5.8v20.14h-5.8v-20.14z"/>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'icon-deploy'"
    xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41">
     <g fill="none" fill-rule="evenodd" stroke="#FFF">
        <path stroke-linejoin="round" stroke-width="1.5" d="M14 20.891l7.76-12.444L36.706 5l-2.707 13.53-13.123 9.693zM19.2 11.881L8.533 15.287l6.528 3.777zM30.249 21.86l-2.08 11.003-4.545-6.018z"/>
        <path stroke-linecap="round" stroke-width="1.2" d="M14.06 27.5l-8.56 9M16.5 29.223l-4 6.277M12.5 25.5l-7 5"/>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'icon-labels'"
    xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41">

    <g fill="none" fill-rule="evenodd" stroke="#FFF">
      <path stroke-linejoin="round" stroke-width="1.5" d="M25.256 29.75H5.25v-18.5h20.006l11.97 9.25-11.97 9.25z"/>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'icon-users'"
    xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41">

    <g fill="none" fill-rule="evenodd">
        <g stroke="#FFF" stroke-width="1.576" transform="translate(5 12)">
            <ellipse cx="8.036" cy="4.705" rx="4.821" ry="4.705"/>
            <path d="M7.441 12.288a6.183 6.183 0 0 0-5.629 3.624l-.756 1.664a3.279 3.279 0 0 0 2.985 4.636h6.954a3.243 3.243 0 0 0 2.933-4.626l-.797-1.69a6.29 6.29 0 0 0-5.69-3.608z"/>
        </g>
        <g transform="translate(20 9)" ill="none" fill-rule="evenodd" stroke-width="1.576">
            <circle cx="7.7" cy="4.5" r="4.5"/>
            <path d="M7.441 12.288a6.183 6.183 0 0 0-5.629 3.624l-.756 1.664a3.279 3.279 0 0 0 2.985 4.636h6.954a3.243 3.243 0 0 0 2.933-4.626l-.797-1.69a6.29 6.29 0 0 0-5.69-3.608z"/>
        </g>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'icon-remotes'"
    xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41">

    <g fill="none" fill-rule="evenodd">
        <path fill="#FFF" fill-rule="nonzero" d="M 25.625 15.375 L 15.375 15.375 C 14.433594 15.375 13.667969 16.144531 13.667969 17.082031 L 13.667969 37.582031 C 13.667969 38.523438 14.433594 39.292969 15.375 39.292969 L 25.625 39.292969 C 26.566406 39.292969 27.332031 38.523438 27.332031 37.582031 L 27.332031 17.082031 C 27.332031 16.144531 26.566406 15.375 25.625 15.375 Z M 20.5 25.625 C 18.621094 25.625 17.082031 24.085938 17.082031 22.207031 C 17.082031 20.328125 18.621094 18.792969 20.5 18.792969 C 22.378906 18.792969 23.917969 20.328125 23.917969 22.207031 C 23.917969 24.085938 22.378906 25.625 20.5 25.625 Z M 12.042969 10.335938 L 14.453125 12.746094 C 16.007812 11.207031 18.140625 10.25 20.5 10.25 C 22.859375 10.25 24.992188 11.207031 26.546875 12.746094 L 28.957031 10.335938 C 26.785156 8.164062 23.796875 6.832031 20.5 6.832031 C 17.203125 6.832031 14.214844 8.164062 12.042969 10.335938 Z M 20.5 0 C 15.308594 0 10.609375 2.101562 7.210938 5.5 L 9.617188 7.910156 C 12.402344 5.140625 16.246094 3.417969 20.5 3.417969 C 24.753906 3.417969 28.597656 5.140625 31.363281 7.925781 L 33.773438 5.519531 C 30.390625 2.101562 25.691406 0 20.5 0 Z M 20.5 0 "/>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'icon-data'"
    xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41">

    <g>
      <rect
        id="canvas_background"
        fill="none"
        height="52"
        width="52"
        y="-1"
        x="-1"/>
    </g>
    <g>
      <path
        id="svg_1"
        fill="#1b1b1b"
        d="m15.344613,35.353758l0,4.572c0.151,0.54 3.15,2 9,2s8.839,-1.455 9,-2.012l0,-4.56c-2.128,1.072 -5.643,1.572 -9,1.572s-6.872,-0.5 -9,-1.572zm10,5.572l-2,0l0,-2l2,0l0,2z"/>
      <path
        id="svg_2"
        fill="#1b1b1b"
        d="m33.251806,19.668217c-0.2,-0.566 -3.2,-2 -9,-2c-5.841,0 -8.839,1.455 -9,2.012l0,0.006c0.161,0.526 3.159,1.982 9,1.982c5.8,0 8.8,-1.434 9,-2z"/>
      <path
        id="svg_3"
        stroke-width="2"
        fill="#1b1b1b"
        d="m4.445372,21.719262l10.30958,0l0,-3.120054c0,-2.143477 4.897051,-3.120054 9.450449,-3.120054s9.450449,0.976577 9.450449,3.120054l0,3.120054l6.013922,0a8.591317,7.800134 0 0 0 0,-15.600268l-0.52407,0a0.859132,0.780013 0 0 1 -0.810161,-0.519489a8.149723,7.399207 0 0 0 -15.097521,-0.620111a0.859132,0.780013 0 0 1 -1.390934,0.222304a8.161751,7.410127 0 0 0 -13.965186,5.20737l0,2.730047a0.859132,0.780013 0 0 1 -0.859132,0.780013l-2.577395,0a4.295658,3.900067 0 0 0 0,7.800134zm40.379189,-5.460094l-1.718263,0l0,-1.560027l1.718263,0l0,1.560027zm-5.15479,-6.240107a5.159945,4.684761 0 0 1 5.15479,4.680081l-1.718263,0a3.436527,3.120054 0 0 0 -3.436527,-3.120054l0,-1.560027z"/>
      <path
        id="svg_4"
        fill="#1b1b1b"
        d="m33.251806,28.446565c-2.128,1.067 -5.643,1.572 -9,1.572s-6.872,-0.505 -9,-1.572l0,4.572c0.151,0.54 3.15,2 9,2s8.839,-1.455 9,-2.012l0,-4.56zm-8,5.572l-2,0l0,-2l2,0l0,2z"/>
      <path
        id="svg_5"
        fill="#1b1b1b"
        d="m33.158998,21.446565c-2.128,1.072 -5.643,1.572 -9,1.572s-6.872,-0.5 -9,-1.572l0,4.572c0.151,0.54 3.15,2 9,2s8.839,-1.455 9,-2.012l0,-4.56zm-8,5.572l-2,0l0,-2l2,0l0,2z"/>
      <path
        id="svg_6"
        stroke-width="2"
        fill="#1b1b1b"
        d="m48.033712,47.482972l-20.4405,0a3.127611,3.594988 0 0 0 -2.234678,-2.568619l0,-2.823863l-1.563805,0l0,2.823863a3.127611,3.594988 0 0 0 -2.234678,2.568619l-20.4405,0l0,1.797494l20.4405,0a3.112755,3.577911 0 0 0 6.033161,0l20.4405,0l0,-1.797494zm-23.45708,2.696241a1.563805,1.797494 0 1 1 1.563805,-1.797494a1.563805,1.797494 0 0 1 -1.563805,1.797494z"/>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'icon-notifications'"
    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="33pt" height="33pt" viewBox="0 0 33 33" version="1.1">

    <g id="surface1" style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;">
      <path d="M 26.761719 20.050781 C 24.296875 17.976562 24.300781 11.871094 24.300781 11.808594 C 24.300781 7.191406 20.527344 5.394531 19.402344 4.964844 C 19.046875 3.765625 17.914062 2.925781 16.59375 2.925781 C 15.28125 2.925781 14.152344 3.757812 13.789062 4.953125 C 8.910156 6.726562 8.859375 11.757812 8.859375 11.8125 C 8.859375 18.160156 6.527344 20.003906 6.476562 20.039062 C 4.960938 21.332031 4.886719 23.128906 4.886719 23.289062 C 5.175781 25.339844 6.527344 26.066406 7.703125 26.066406 L 25.304688 26.0625 C 26.195312 26.0625 26.917969 25.804688 27.441406 25.292969 C 28.28125 24.476562 28.277344 23.320312 28.277344 23.277344 C 28.277344 21.203125 26.792969 20.082031 26.761719 20.050781 Z M 26.644531 24.550781 C 26.339844 24.847656 25.886719 24.996094 25.308594 24.996094 L 7.769531 25 L 7.707031 25.539062 L 7.707031 25.003906 C 7.269531 25.003906 6.234375 24.820312 6 23.242188 C 6 23.222656 6.070312 21.824219 7.1875 20.871094 C 7.300781 20.789062 9.980469 18.765625 9.980469 11.8125 C 9.980469 11.765625 10.027344 7.300781 14.402344 5.871094 C 14.621094 5.824219 14.777344 5.65625 14.816406 5.449219 C 14.964844 4.609375 15.710938 4 16.597656 4 C 17.480469 4 18.234375 4.613281 18.375 5.460938 C 18.410156 5.65625 18.558594 5.816406 18.753906 5.878906 C 18.9375 5.9375 23.1875 7.277344 23.1875 11.8125 C 23.1875 12.085938 23.179688 18.464844 26.050781 20.882812 C 26.101562 20.917969 27.164062 21.75 27.164062 23.289062 C 27.160156 23.292969 27.15625 24.054688 26.644531 24.550781 Z M 20.667969 26.6875 C 20.402344 26.597656 20.125 26.738281 20.03125 27.015625 C 19.625 28.28125 18.203125 29.164062 16.578125 29.164062 C 14.953125 29.164062 13.53125 28.28125 13.125 27.019531 C 13.035156 26.742188 12.75 26.605469 12.492188 26.691406 C 12.226562 26.789062 12.09375 27.09375 12.183594 27.371094 C 12.734375 29.0625 14.539062 30.234375 16.578125 30.234375 C 18.621094 30.234375 20.425781 29.058594 20.972656 27.371094 C 21.0625 27.089844 20.929688 26.789062 20.667969 26.6875 "/>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'icon-network-config'"
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="41"
    viewBox="0 0 41 41">
    <g
      fill="none"
      fill-rule="evenodd"
      stroke="#FFF">
      <circle
        cx="10.5"
        cy="22.5"
        r="4.5"
        stroke-width="1.5"/>
      <circle
        cx="30.5"
        cy="30.5"
        r="4.5"
        stroke-width="1.5"/>
      <circle
        cx="30.5"
        cy="10.5"
        r="4.5"
        stroke-width="1.5"/>
      <path
        stroke-linecap="square"
        stroke-width="2"
        d="M25.415 29l-10.263-5M25.415 13.237l-10.263 6.776"/>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'icon-logout'"
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28">
    <g
      fill="#FFF"
      fill-rule="nonzero">
      <path d="M27.89 12.945c0-.11-.037-.222-.074-.333-.037-.037-.074-.11-.11-.148-.038-.037-.038-.074-.074-.11l-4.68-4.735a.82.82 0 0 0-1.178 0c-.332.333-.332.962 0 1.295l3.279 3.402H8.732a.859.859 0 0 0-.848.851c0 .444.369.85.848.85h16.32l-3.278 3.219a.785.785 0 0 0 0 1.146c.331.333.847.296 1.179-.037l4.715-4.734c.037-.037.074-.074.074-.148.037-.037.074-.074.074-.148.073-.148.073-.259.073-.37z"/>
      <path d="M16.91 18.789v6.51H1.917V1.886H16.91V7.99h1.657V.886c0-.924.3-.664-.547-.664H.805c-.847 0-.547-.26-.547.664V26.3c0 .924-.3.664.547.664h17.216c.847 0 .547.26.547-.664v-7.51h-1.657z"/>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'icon-close'"
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="41"
    viewBox="0 0 41 41">
    <g
      fill="#FFF"
      fill-rule="evenodd">
      <rect
        width="35"
        height="2"
        x="3"
        y="7"
        fill-rule="nonzero"
        rx="1"/>
      <rect
        width="35"
        height="2"
        x="3"
        y="20"
        fill-rule="nonzero"
        rx="1"/>
      <rect
        width="20"
        height="2"
        x="3"
        y="33"
        fill-rule="nonzero"
        rx="1"/>
      <path
        stroke="#FFF"
        stroke-linejoin="round"
        d="M30.125 34.375l6.75-4.5v9z"/>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'icon-docker'"
    xmlns="http://www.w3.org/2000/svg"
    width="90"
    height="90"
    viewBox="0 0 90 90">
    <g
      fill="#FFF"
      fill-rule="nonzero">
      <path d="M88.614 37.558c-.238-.19-2.503-1.922-7.282-1.922-1.264 0-2.515.114-3.767.329-.926-6.399-6.156-9.522-6.394-9.661l-1.276-.747-.838 1.227a17.62 17.62 0 0 0-2.277 5.387c-.851 3.655-.338 7.082 1.501 10.016-2.215 1.252-5.78 1.555-6.494 1.58H2.89c-1.539 0-2.79 1.265-2.79 2.808-.062 5.21.8 10.395 2.578 15.289 2.027 5.374 5.042 9.332 8.971 11.76 4.405 2.72 11.55 4.275 19.657 4.275 3.667.012 7.32-.329 10.911-1a44.872 44.872 0 0 0 14.24-5.235 39.532 39.532 0 0 0 9.722-8.042c4.667-5.337 7.445-11.28 9.51-16.567h.825c5.105 0 8.246-2.06 9.985-3.793a10.887 10.887 0 0 0 2.628-3.946l.363-1.087-.876-.67z"/>
      <path d="M8.346 42.022h7.895a.698.698 0 0 0 .688-.695V34.22a.69.69 0 0 0-.688-.696H8.346a.698.698 0 0 0-.688.696v7.107c0 .38.313.695.688.695M19.22 42.022h7.895a.698.698 0 0 0 .688-.695V34.22a.69.69 0 0 0-.688-.696h-7.896a.69.69 0 0 0-.688.696v7.107c0 .38.313.695.688.695M30.268 42.022h7.895a.698.698 0 0 0 .689-.695V34.22a.69.69 0 0 0-.689-.696h-7.895a.698.698 0 0 0-.688.696v7.107c0 .38.3.695.688.695M41.179 42.022h7.895a.698.698 0 0 0 .688-.695V34.22a.69.69 0 0 0-.688-.696H41.18a.698.698 0 0 0-.688.696v7.107c0 .38.3.695.688.695M19.22 31.804h7.895a.698.698 0 0 0 .688-.695v-7.107a.698.698 0 0 0-.688-.696h-7.896a.698.698 0 0 0-.688.696v7.107c0 .38.313.695.688.695M30.268 31.804h7.895a.698.698 0 0 0 .689-.695v-7.107a.698.698 0 0 0-.689-.696h-7.895a.698.698 0 0 0-.688.696v7.107c0 .38.3.695.688.695M41.179 31.804h7.895a.69.69 0 0 0 .688-.695v-7.107a.698.698 0 0 0-.688-.696H41.18a.698.698 0 0 0-.688.696v7.107c0 .38.3.695.688.695M41.179 21.574h7.895a.698.698 0 0 0 .688-.696v-7.107a.698.698 0 0 0-.688-.695H41.18a.698.698 0 0 0-.688.695v7.107c0 .392.3.696.688.696M52.177 42.022h7.896a.698.698 0 0 0 .688-.695V34.22a.69.69 0 0 0-.688-.696h-7.896a.698.698 0 0 0-.688.696v7.107c0 .38.313.695.688.695"/>
    </g>
  </svg>

  <svg
    v-else-if="iconName === 'codesys'"
    xmlns="http://www.w3.org/2000/svg"
    width="90"
    height="90"
    viewBox="0 0 90 90">
    <g
      fill="#FFF"
      fill-rule="nonzero">
      <path d="M45 31.49l.022.007 19.034-10.969L45 9.051 25.944 20.535l19.034 10.97.022-.015zm-.007-20.48l.007.008.007-.007 15.746 9.495L45 29.581l-15.753-9.075 15.746-9.495zM23.417 22.249l-17.96 10.83 18.055 10.934L42.72 33.276 23.417 22.249zM8.695 33.087l14.751-8.893 15.877 9.075-15.775 8.805-14.853-8.987zM24.898 69.603l18.788 10.78V58.815l-18.788-10.78zM5.007 58.082L22.54 68.448V46.88L5.007 36.1zM66.583 22.249L47.279 33.276l19.21 10.737 18.06-10.926L66.584 22.25zm-.131 19.825l-15.768-8.813 15.877-9.074 14.751 8.893-14.86 8.994zM46.314 80.383l18.788-10.78V48.034l-18.788 10.78zM67.461 46.88v21.568l17.532-10.366V36.1zM45 34.735l-19.1 10.89 19.1 11.1 19.1-11.1z"/>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'docker'"
    xmlns="http://www.w3.org/2000/svg"
    width="90"
    height="90"
    viewBox="0 0 90 90">
    <g
      fill="#FFF"
      fill-rule="nonzero">
      <path d="M45 31.49l.022.007 19.034-10.969L45 9.051 25.944 20.535l19.034 10.97.022-.015zm-.007-20.48l.007.008.007-.007 15.746 9.495L45 29.581l-15.753-9.075 15.746-9.495zM23.417 22.249l-17.96 10.83 18.055 10.934L42.72 33.276 23.417 22.249zM8.695 33.087l14.751-8.893 15.877 9.075-15.775 8.805-14.853-8.987zM24.898 69.603l18.788 10.78V58.815l-18.788-10.78zM5.007 58.082L22.54 68.448V46.88L5.007 36.1zM66.583 22.249L47.279 33.276l19.21 10.737 18.06-10.926L66.584 22.25zm-.131 19.825l-15.768-8.813 15.877-9.074 14.751 8.893-14.86 8.994zM46.314 80.383l18.788-10.78V48.034l-18.788 10.78zM67.461 46.88v21.568l17.532-10.366V36.1zM45 34.735l-19.1 10.89 19.1 11.1 19.1-11.1z"/>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'codesys-manage-icon'"
    xmlns="http://www.w3.org/2000/svg"
    width="90"
    height="90"
    viewBox="0 0 90 90">
    <g
      fill="#FFF"
      fill-rule="nonzero">
      <path d="M45 31.49l.022.007 19.034-10.969L45 9.051 25.944 20.535l19.034 10.97.022-.015zm-.007-20.48l.007.008.007-.007 15.746 9.495L45 29.581l-15.753-9.075 15.746-9.495zM23.417 22.249l-17.96 10.83 18.055 10.934L42.72 33.276 23.417 22.249zM8.695 33.087l14.751-8.893 15.877 9.075-15.775 8.805-14.853-8.987zM24.898 69.603l18.788 10.78V58.815l-18.788-10.78zM5.007 58.082L22.54 68.448V46.88L5.007 36.1zM66.583 22.249L47.279 33.276l19.21 10.737 18.06-10.926L66.584 22.25zm-.131 19.825l-15.768-8.813 15.877-9.074 14.751 8.893-14.86 8.994zM46.314 80.383l18.788-10.78V48.034l-18.788 10.78zM67.461 46.88v21.568l17.532-10.366V36.1zM45 34.735l-19.1 10.89 19.1 11.1 19.1-11.1z"/>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'docker-manage-icon'"
    xmlns="http://www.w3.org/2000/svg"
    width="90"
    height="90"
    viewBox="0 0 90 90">
    <g
      fill="#FFF"
      fill-rule="nonzero">
      <path d="M88.614 37.558c-.238-.19-2.503-1.922-7.282-1.922-1.264 0-2.515.114-3.767.329-.926-6.399-6.156-9.522-6.394-9.661l-1.276-.747-.838 1.227a17.62 17.62 0 0 0-2.277 5.387c-.851 3.655-.338 7.082 1.501 10.016-2.215 1.252-5.78 1.555-6.494 1.58H2.89c-1.539 0-2.79 1.265-2.79 2.808-.062 5.21.8 10.395 2.578 15.289 2.027 5.374 5.042 9.332 8.971 11.76 4.405 2.72 11.55 4.275 19.657 4.275 3.667.012 7.32-.329 10.911-1a44.872 44.872 0 0 0 14.24-5.235 39.532 39.532 0 0 0 9.722-8.042c4.667-5.337 7.445-11.28 9.51-16.567h.825c5.105 0 8.246-2.06 9.985-3.793a10.887 10.887 0 0 0 2.628-3.946l.363-1.087-.876-.67z"/>
      <path d="M8.346 42.022h7.895a.698.698 0 0 0 .688-.695V34.22a.69.69 0 0 0-.688-.696H8.346a.698.698 0 0 0-.688.696v7.107c0 .38.313.695.688.695M19.22 42.022h7.895a.698.698 0 0 0 .688-.695V34.22a.69.69 0 0 0-.688-.696h-7.896a.69.69 0 0 0-.688.696v7.107c0 .38.313.695.688.695M30.268 42.022h7.895a.698.698 0 0 0 .689-.695V34.22a.69.69 0 0 0-.689-.696h-7.895a.698.698 0 0 0-.688.696v7.107c0 .38.3.695.688.695M41.179 42.022h7.895a.698.698 0 0 0 .688-.695V34.22a.69.69 0 0 0-.688-.696H41.18a.698.698 0 0 0-.688.696v7.107c0 .38.3.695.688.695M19.22 31.804h7.895a.698.698 0 0 0 .688-.695v-7.107a.698.698 0 0 0-.688-.696h-7.896a.698.698 0 0 0-.688.696v7.107c0 .38.313.695.688.695M30.268 31.804h7.895a.698.698 0 0 0 .689-.695v-7.107a.698.698 0 0 0-.689-.696h-7.895a.698.698 0 0 0-.688.696v7.107c0 .38.3.695.688.695M41.179 31.804h7.895a.69.69 0 0 0 .688-.695v-7.107a.698.698 0 0 0-.688-.696H41.18a.698.698 0 0 0-.688.696v7.107c0 .38.3.695.688.695M41.179 21.574h7.895a.698.698 0 0 0 .688-.696v-7.107a.698.698 0 0 0-.688-.695H41.18a.698.698 0 0 0-.688.695v7.107c0 .392.3.696.688.696M52.177 42.022h7.896a.698.698 0 0 0 .688-.695V34.22a.69.69 0 0 0-.688-.696h-7.896a.698.698 0 0 0-.688.696v7.107c0 .38.313.695.688.695"/>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'vm'"
    xmlns="http://www.w3.org/2000/svg"
    width="90"
    height="90"
    viewBox="0 0 90 90">
    <g
      fill="none"
      fill-rule="nonzero">
      <path
        fill="#FFF"
        d="M45.4 17.174l36.497 15.91a1 1 0 0 1 0 1.833L45.4 50.826a1 1 0 0 1-.8 0L8.103 34.916a1 1 0 0 1 0-1.833L44.6 17.174a1 1 0 0 1 .8 0z"/>
      <path
        stroke="#FFF"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="3"
        d="M83 57.5L45 74 7 57.5"/>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'vm-manage-icon'"
    xmlns="http://www.w3.org/2000/svg"
    width="90"
    height="90"
    viewBox="0 0 90 90">
    <g
      fill="none"
      fill-rule="nonzero">
      <path
        fill="#FFF"
        d="M45.4 17.174l36.497 15.91a1 1 0 0 1 0 1.833L45.4 50.826a1 1 0 0 1-.8 0L8.103 34.916a1 1 0 0 1 0-1.833L44.6 17.174a1 1 0 0 1 .8 0z"/>
      <path
        stroke="#FFF"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="3"
        d="M83 57.5L45 74 7 57.5"/>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'deploy'"
    xmlns="http://www.w3.org/2000/svg"
    width="90"
    height="90"
    viewBox="0 0 90 90">
    <g
      fill="#FFF"
      fill-rule="nonzero">
      <path d="M23.157 27.47l-1.837 1.356a.75.75 0 0 1-.992-.09l-6.875-7.332a.75.75 0 0 1-.09-.91l.709-1.135-5.916-3.423a.75.75 0 0 1 .148-1.364l10.668-3.405a.77.77 0 0 1 .232-.038l1.92-3.079a.75.75 0 0 1 .468-.334L36.536 4.27a.75.75 0 0 1 .904.878l-2.707 13.53a.75.75 0 0 1-.29.456l-3.46 2.556c.021.096.024.2.004.31l-2.08 11.004a.75.75 0 0 1-1.336.313l-4.414-5.846zm-2.191-.246l12.353-9.126 2.423-12.106-13.51 3.116-7.29 11.691 6.024 6.425zm-6.181-9.185l2.798-4.854-7.21 2.301 4.412 2.553zm9.891 8.954l3.071 4.067 1.406-7.436-4.477 3.369zm-11.051.094a.6.6 0 0 1 .87.826l-8.56 9a.6.6 0 0 1-.87-.826l8.56-9zm2.369 1.814a.6.6 0 1 1 1.012.645l-4 6.276a.6.6 0 0 1-1.012-.644l4-6.277zm-3.843-3.89a.6.6 0 1 1 .698.977l-7 5a.6.6 0 1 1-.698-.976l7-5z"/>
    </g>
  </svg>

  <svg
    v-else-if="iconName === 'repo'"
    viewBox="0 0 24 24">
    <g
      stroke="#FFF">
      <path
        d="M20 21H4V10H6V19H18V10H20V21M3 3H21V9H3V3M5 5V7H19V5M10.5 11V14H8L12 18L16 14H13.5V11"
      />
    </g>
  </svg>

  <svg
    v-else-if="iconName === 'node-configuration'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      stroke="#FFF">
      <path
        d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-1.75 9c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42c-.09-.15-.05-.34.08-.45l1.48-1.16c-.03-.23-.05-.46-.05-.69s.02-.46.05-.68l-1.48-1.16c-.13-.11-.17-.3-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.23.05.46.05.69z"
      />
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'remote-connect'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24">
    <g stroke="#FFF">
      <path d="M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-3 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM7.05 6.05l1.41 1.41C9.37 6.56 10.62 6 12 6s2.63.56 3.54 1.46l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z"/>
    </g>
  </svg>

  <svg
    v-else-if="iconName === 'offline'"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20">
    <defs>
      <linearGradient
        id="a"
        x1="50%"
        x2="50%"
        y1="0%"
        y2="99.665%">
        <stop
          offset="0%"
          stop-color="#FF1E00"/>
        <stop
          offset="100%"
          stop-color="#FF7E01"/>
      </linearGradient>
    </defs>
    <g
      fill="none"
      fill-rule="evenodd">
      <circle
        cx="10"
        cy="10"
        r="10"
        fill="url(#a)"/>
      <path
        stroke="#FFF"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M10 10l3-3-3 3-3-3 3 3zm0 0l-3 3 3-3 3 3-3-3z"/>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'online'"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20">
    <defs>
      <linearGradient
        id="a"
        x1="50%"
        x2="50%"
        y1="0%"
        y2="100%">
        <stop
          offset="0%"
          stop-color="#0DDB77"/>
        <stop
          offset="100%"
          stop-color="#0AB130"/>
      </linearGradient>
    </defs>
    <g
      fill="none"
      fill-rule="evenodd">
      <circle
        cx="10"
        cy="10"
        r="10"
        fill="url(#a)"/>
      <path
        stroke="#FFF"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M5.415 9.91l2.795 4.144L5.415 9.91zm8.72-4.202L8.36 13.87l5.776-8.162z"/>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'configuration'"
    width="60"
    height="100"
    xmlns="http://www.w3.org/2000/svg">

    <g>
      <rect
        id="canvas_background"
        fill="none"
        height="52"
        width="52"
        y="-1"
        x="-1"/>
    </g>
    <g>
      <path
        id="svg_1"
        fill="#3698d3"
        d="m15.344613,35.353758l0,4.572c0.151,0.54 3.15,2 9,2s8.839,-1.455 9,-2.012l0,-4.56c-2.128,1.072 -5.643,1.572 -9,1.572s-6.872,-0.5 -9,-1.572zm10,5.572l-2,0l0,-2l2,0l0,2z"/>
      <path
        id="svg_2"
        fill="#3698d3"
        d="m33.251806,19.668217c-0.2,-0.566 -3.2,-2 -9,-2c-5.841,0 -8.839,1.455 -9,2.012l0,0.006c0.161,0.526 3.159,1.982 9,1.982c5.8,0 8.8,-1.434 9,-2z"/>
      <path
        id="svg_3"
        stroke="null"
        fill="#3698d3"
        d="m4.445372,21.719262l10.30958,0l0,-3.120054c0,-2.143477 4.897051,-3.120054 9.450449,-3.120054s9.450449,0.976577 9.450449,3.120054l0,3.120054l6.013922,0a8.591317,7.800134 0 0 0 0,-15.600268l-0.52407,0a0.859132,0.780013 0 0 1 -0.810161,-0.519489a8.149723,7.399207 0 0 0 -15.097521,-0.620111a0.859132,0.780013 0 0 1 -1.390934,0.222304a8.161751,7.410127 0 0 0 -13.965186,5.20737l0,2.730047a0.859132,0.780013 0 0 1 -0.859132,0.780013l-2.577395,0a4.295658,3.900067 0 0 0 0,7.800134zm40.379189,-5.460094l-1.718263,0l0,-1.560027l1.718263,0l0,1.560027zm-5.15479,-6.240107a5.159945,4.684761 0 0 1 5.15479,4.680081l-1.718263,0a3.436527,3.120054 0 0 0 -3.436527,-3.120054l0,-1.560027z"/>
      <path
        id="svg_4"
        fill="#3698d3"
        d="m33.251806,28.446565c-2.128,1.067 -5.643,1.572 -9,1.572s-6.872,-0.505 -9,-1.572l0,4.572c0.151,0.54 3.15,2 9,2s8.839,-1.455 9,-2.012l0,-4.56zm-8,5.572l-2,0l0,-2l2,0l0,2z"/>
      <path
        id="svg_5"
        fill="#3698d3"
        d="m33.158998,21.446565c-2.128,1.072 -5.643,1.572 -9,1.572s-6.872,-0.5 -9,-1.572l0,4.572c0.151,0.54 3.15,2 9,2s8.839,-1.455 9,-2.012l0,-4.56zm-8,5.572l-2,0l0,-2l2,0l0,2z"/>
      <path
        id="svg_6"
        stroke="null"
        fill="#3698d3"
        d="m48.033712,47.482972l-20.4405,0a3.127611,3.594988 0 0 0 -2.234678,-2.568619l0,-2.823863l-1.563805,0l0,2.823863a3.127611,3.594988 0 0 0 -2.234678,2.568619l-20.4405,0l0,1.797494l20.4405,0a3.112755,3.577911 0 0 0 6.033161,0l20.4405,0l0,-1.797494zm-23.45708,2.696241a1.563805,1.797494 0 1 1 1.563805,-1.797494a1.563805,1.797494 0 0 1 -1.563805,1.797494z"/>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'icon-lang-en'"
    xmlns="http://www.w3.org/2000/svg"
    height="480"
    width="640"
    viewBox="0 0 640 480">
    <g
      transform="translate(80) scale(.94)">
      <g stroke-width="1pt">
        <path
          fill="#006"
          d="M-256 0H768.02v512.01H-256z"/>
        <path
          d="M-256 0v57.244l909.535 454.768H768.02V454.77L-141.515 0H-256zM768.02 0v57.243L-141.515 512.01H-256v-57.243L653.535 0H768.02z"
          fill="#fff"/>
        <path
          d="M170.675 0v512.01h170.67V0h-170.67zM-256 170.67v170.67H768.02V170.67H-256z"
          fill="#fff"/>
        <path
          d="M-256 204.804v102.402H768.02V204.804H-256zM204.81 0v512.01h102.4V0h-102.4zM-256 512.01L85.34 341.34h76.324l-341.34 170.67H-256zM-256 0L85.34 170.67H9.016L-256 38.164V0zm606.356 170.67L691.696 0h76.324L426.68 170.67h-76.324zM768.02 512.01L426.68 341.34h76.324L768.02 473.848v38.162z"
          fill="#c00"/>
      </g>
    </g>
  </svg>
  <svg
    v-else-if="iconName === 'icon-lang-de'"
    xmlns="http://www.w3.org/2000/svg"
    height="480"
    width="640"
    viewBox="0 0 640 480">
    <path
      fill="#ffce00"
      d="M0 320h640v160.002H0z"/>
    <path d="M0 0h640v160H0z"/>
    <path
      fill="#d00"
      d="M0 160h640v160H0z"/>
  </svg>
  <svg
    v-else-if="iconName === 'icon-lang-ko'"
    xmlns="http://www.w3.org/2000/svg"
    height="480"
    width="640"
    viewBox="0 0 640 480">
    <g
      fill-rule="evenodd"
      transform="translate(89.82 .412) scale(.9375)">
      <path
        fill="#fff"
        d="M610.61 511.56h-730.17v-512h730.17z"/>
      <path
        d="M251.871 256.021c0 62.137-50.372 112.508-112.507 112.508-62.137 0-112.507-50.372-112.507-112.508 0-62.137 50.371-112.507 112.507-112.507 62.137 0 112.507 50.372 112.507 112.507z"
        fill="#fff"/>
      <path
        d="M393.011 262.55c0 81.079-65.034 146.803-145.261 146.803S102.488 343.63 102.488 262.55s65.034-146.804 145.262-146.804S393.01 181.471 393.01 262.55z"
        fill="#c70000"/>
      <path d="M-49.417 126.44l83.66-96.77 19.821 17.135-83.66 96.771zM-22.018 150.127l83.66-96.77 19.82 17.135-83.66 96.77z"/>
      <path d="M-49.417 126.44l83.66-96.77 19.821 17.135-83.66 96.771z"/>
      <path d="M-49.417 126.44l83.66-96.77 19.821 17.135-83.66 96.771zM5.967 174.32l83.66-96.77 19.82 17.136-83.66 96.77z"/>
      <path d="M-49.417 126.44l83.66-96.77 19.821 17.135-83.66 96.771z"/>
      <path d="M-49.417 126.44l83.66-96.77 19.821 17.135-83.66 96.771zM459.413 29.638l83.002 97.335-19.937 17-83.002-97.334zM403.707 77.141l83.002 97.335-19.936 17-83.002-97.334z"/>
      <path
        d="M417.55 133.19l78.602-67.814 14.641 16.953-83.996 75.519-9.247-24.659z"
        fill="#fff"/>
      <path d="M514.228 372.013l-80.416 95.829-19.716-16.4 80.417-95.828zM431.853 53.14l83.002 97.334-19.936 17.001-83.002-97.334zM541.475 394.676l-80.417 95.829-19.715-16.399 80.417-95.829zM486.39 348.857l-80.417 95.83-19.715-16.4 80.416-95.829z"/>
      <path
        d="M104.6 236.68c4.592 36.974 11.297 78.175 68.199 82.455 21.328 1.278 62.817-5.074 77.061-63.19 18.688-55.829 74.975-71.88 113.28-41.613 21.718 14.166 27.727 36.666 29.283 53.557-1.739 54.243-32.874 101.2-72.823 122.14-45.93 27.3-109.56 27.87-165.3-13.49-25.12-23.57-60.219-67.02-49.7-139.86z"
        fill="#3d5897"/>
      <path
        d="M435.91 370.59l78.734 67.661-14.591 16.997-87.156-71.851 23.013-12.807z"
        fill="#fff"/>
      <path d="M-1.887 357.197l83.002 97.335-19.937 17-83.002-97.334z"/>
      <path
        d="M-16.188 437.25l78.602-67.814 14.641 16.953-83.996 75.519-9.247-24.659z"
        fill="#fff"/>
      <path d="M25.672 333.696l83.003 97.334-19.937 17-83.002-97.334zM-30.033 381.199l83.002 97.334-19.936 17L-49.97 398.2z"/>
    </g>
  </svg>
<svg
    v-else-if="iconName === 'system-update'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path d="M0 .5h24v24H0z" fill="none"/>
    <path 
      fill="#000000" 
      stroke="#000000" 
      stroke-width="1" 
      d="M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2
      .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z"
    />
  </svg>
  <svg
    v-else-if="iconName === 'system-update-blue'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path d="M0 .5h24v24H0z" fill="none"/>
    <path 
      fill="#0093D0" 
      stroke="#0093D0" 
      stroke-width="1" 
      d="M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2
      .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z"
    />
  </svg>
  <svg 
    v-else-if="iconName === 'report-blue'"
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    version="1.1"  
    width="24" 
    height="24" 
    viewBox="0 0 24 24"
  >    
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <path 
        fill="#0093D0" 
        d="M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89
        4.89,2 6,2M7,20H9V14H7V20M11,20H13V12H11V20M15,20H17V16H15V20Z"
      />
    </g>
  </svg>
  <svg 
    v-else-if="iconName === 'report'"
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    version="1.1"  
    width="24" 
    height="24" 
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <path 
        fill="#000000" 
        d="M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89
        4.89,2 6,2M7,20H9V14H7V20M11,20H13V12H11V20M15,20H17V16H15V20Z"
      />
    </g>
  </svg>
  <svg v-else-if="iconName === 'deploy_icon'" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2107_4753)">
    <path d="M14.4732 0.552675L19.4646 5.54404C19.4646 5.54404 19.6028 5.56131 19.62 5.5095C20.38 2.8152 19.8618 0.500861 19.7928 0.259065C19.7928 0.259065 19.7928 0.241794 19.7582 0.224523C19.4991 0.155438 17.2021 -0.362697 14.5078 0.397234C14.4387 0.414505 14.4214 0.500861 14.4732 0.552675Z" fill="#0093D0"/>
    <path d="M18.9292 6.89119L13.1433 1.10535C13.1433 1.10535 12.9361 1.00173 12.8325 1.05354C11.9171 1.50259 10.449 2.65976 9.56821 3.52331C8.29014 4.80138 7.21933 6.45941 6.40759 8.03109C4.93954 8.60104 3.16061 6.96027 0.0690731 11.1917C-0.0345538 11.3299 -0.0345538 11.5371 0.138158 11.6235C0.673564 11.8998 4.09325 11.9344 4.59412 12.1934C4.52503 12.3661 4.47322 12.5216 4.43868 12.6598C4.33505 12.9706 4.42141 13.3333 4.64593 13.5579L5.5613 14.4732L6.47667 15.3886C6.71847 15.6304 7.06389 15.7168 7.37477 15.5959C7.51294 15.544 7.66838 15.4922 7.85837 15.4231C7.85837 15.4577 7.85837 15.4922 7.87564 15.5268C8.1347 16.0276 8.11743 19.3264 8.39377 19.8791C8.48013 20.0345 8.67011 20.0345 8.82555 19.9482C12.677 17.8584 11.5199 15.1295 12.1243 13.5579C13.6615 12.7461 15.2504 11.7098 16.5112 10.449C17.392 9.56822 18.5492 8.11744 18.9983 7.1848C19.0501 7.08117 19.0328 6.96028 18.9465 6.87392L18.9292 6.89119ZM13.696 8.0829C13.1779 8.60103 12.3316 8.60103 11.8135 8.0829C11.2953 7.56476 11.2953 6.71848 11.8135 6.20034C12.3316 5.68221 13.1779 5.68221 13.696 6.20034C14.2142 6.71848 14.2142 7.56476 13.696 8.0829Z" fill="#0093D0"/>
    <path d="M3.90328 14.5941C3.78238 14.4732 3.60967 14.4387 3.4715 14.5423C2.5734 15.1986 1.26079 16.8221 1.15717 18.6874C1.15717 18.7737 1.22625 18.8428 1.31261 18.8428C3.29879 18.8774 4.95682 17.582 5.59585 16.6494C5.68221 16.5112 5.66494 16.3385 5.54404 16.2176L3.90328 14.5769V14.5941Z" fill="#0093D0"/>
    </g>
    <defs>
    <clipPath id="clip0_2107_4753">
    <rect width="20.0345" height="20" fill="white"/>
    </clipPath>
    </defs>
  </svg>
  <svg v-else-if="iconName === 'update'" width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.5277 3.2C21.1904 3.2 21.7277 2.66274 21.7277 2C21.7277 1.33726 21.1904 0.8 20.5277 0.8V3.2ZM20.5277 0.8H8.72094V3.2H20.5277V0.8ZM5.13777 4.38317V21.7082H7.53777V4.38317H5.13777ZM8.72094 0.8C6.74201 0.8 5.13777 2.40424 5.13777 4.38317H7.53777C7.53777 3.72973 8.06749 3.2 8.72094 3.2V0.8Z" fill="#0093D0"/>
    <path d="M9.10968 25.4941H11.7302" stroke="#225076" stroke-width="2.4" stroke-linecap="round"/>
    <path d="M6.33589 6.72992L6.33589 22.1023M6.33589 22.1023L2.00009 16.9782M6.33589 22.1023L10.6717 16.9782" stroke="#0093D0" stroke-width="2.4" stroke-linecap="round"/>
    <path d="M14.575 24.2941C13.9122 24.2941 13.375 24.8313 13.375 25.4941C13.375 26.1568 13.9122 26.6941 14.575 26.6941L14.575 24.2941ZM14.575 26.6941L21.3018 26.6941L21.3018 24.2941L14.575 24.2941L14.575 26.6941ZM24.8849 23.1109L24.8849 5.83575L22.4849 5.83575L22.4849 23.1109L24.8849 23.1109ZM21.3018 26.6941C23.2807 26.6941 24.8849 25.0898 24.8849 23.1109L22.4849 23.1109C22.4849 23.7644 21.9552 24.2941 21.3018 24.2941L21.3018 26.6941Z" fill="#225076"/>
    <path d="M23.6643 20.7642L23.6643 5.39178M23.6643 5.39178L28.0001 10.5159M23.6643 5.39178L19.3285 10.5159" stroke="#225076" stroke-width="2.4" stroke-linecap="round"/>
  </svg>
</template>

<script>

export default {
  name: 'Icon',
  props: {
    iconName: {
      type: String,
      default: 'icon'
    }
  }
}
</script>
